<template>
  <div class="authcode">
    <div class="feature-container">
      <el-form
        :inline="true"
        :model="searchform"
        class="search-form"
        label-width="90px"
      >
        <el-row>
          <el-col :span="2">
            <el-form-item>
              <el-button type="primary" @click="addAuthcode" size="medium"
                >添加授权设备</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="用户名称：">
              <el-input
                v-model="searchform.userName"
                clearable
                placeholder="请输入用户名称"
                size="medium"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="签发时间：">
              <el-date-picker
                v-model="issueTime"
                type="datetimerange"
                @change="handleIssueTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2" style="padding-left: 30px">
            <el-form-item>
              <el-button type="primary" @click="searchAuthcode" size="medium"
                >按输入条件查询</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <el-form-item label="">
              <el-button type="primary" @click="resetSearchForm" size="medium"
                >重置查询</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="用户分类：">
              <el-select
                v-model="searchform.userGroup"
                clearable
                placeholder="请选择"
              >
                <el-option label="手机用户" value="0"></el-option>
                <el-option label="全站仪用户" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="有效时间：">
              <el-date-picker
                v-model="effectivetime"
                type="datetimerange"
                @change="handleEffTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2" style="padding-left: 30px">
            <el-form-item>
              <el-upload
                ref="seachUpload"
                class="upload-demo"
                action
                accept=".key"
                :auto-upload="false"
                :limit="1"
                :show-file-list="false"
                :on-change="handleFileSeach"
              >
                <el-button size="medium" type="primary"
                  >上传key文件查询</el-button
                >
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="list-container">
      <el-table :data="authCodeList" ref="multiple" border="" height="700">
        <el-table-column
          type="index"
          width="80"
          label="序号"
          :index="indexMethod_authcode"
        ></el-table-column>
        <el-table-column prop="userGroup" label="用户分类">
          <template slot-scope="scope">
            <span v-if="scope.row.userGroup == 0">手机版用户</span>
            <span v-if="scope.row.userGroup == 1">全站仪版用户</span>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="用户名称"></el-table-column>
        <el-table-column
          prop="effectiveTime"
          label="生效时间"
        >
         <template slot-scope="scope">
            {{scope.row.effectiveTime?moment.utc(scope.row.effectiveTime).local().format('YYYY-MM-DD HH:mm:ss'):scope.row.effectiveTime}}
          </template>
        </el-table-column>
        <el-table-column
          prop="expirationTime"
          label="过期时间"
        >
         <template slot-scope="scope">
            {{scope.row.expirationTime?moment.utc(scope.row.expirationTime).local().format('YYYY-MM-DD HH:mm:ss'):scope.row.expirationTime}}
          </template>
        </el-table-column>
        <el-table-column prop="issueTime" label="签发时间">
          <template slot-scope="scope">
            {{scope.row.issueTime?moment.utc(scope.row.issueTime).local().format('YYYY-MM-DD HH:mm:ss'):scope.row.issueTime}}
          </template>
        </el-table-column>
        <el-table-column prop="contractNo" label="合同号"></el-table-column>
        <el-table-column prop="deviceId" label="设备标识"></el-table-column>
        <el-table-column
          prop="moduleNum"
          width="120px"
          label="授权模块编号"
        ></el-table-column>
        <el-table-column
          prop="count"
          width="110px"
          label="权限更新次数"
        ></el-table-column>
        <el-table-column prop="remarks" label="备注信息"></el-table-column>
        <el-table-column prop="validState" width="120px" label="授权码状态">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.validState == -1"
              :type="scope.row.validState === -1 ? 'info' : ''"
            >
              {{ scope.row.validState === -1 ? "未知" : "" }}
            </el-tag>
            <el-tag
              v-if="scope.row.validState == 0"
              :type="scope.row.validState === 0 ? 'warning' : ''"
            >
              {{ scope.row.validState === 0 ? "未生效" : "" }}
            </el-tag>
            <el-tag
              v-if="scope.row.validState == 1"
              :type="scope.row.validState === 1 ? 'success' : ''"
            >
              {{ scope.row.validState === 1 ? "生效中" : "" }}
            </el-tag>
            <el-tag
              v-if="scope.row.validState == 2"
              :type="scope.row.validState === 2 ? 'danger' : ''"
            >
              {{ scope.row.validState === 2 ? "已过期" : "" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="editAuthcode(scope.$index, scope.row)"
              type="text"
              size="small"
              >编辑</el-button
            >
            <el-button
              @click.native.prevent="deleteAuthcode(scope.$index, scope.row)"
              type="text"
              size="small"
              >删除</el-button
            >
            <el-button
              @click.native.prevent="createAuthcode(scope.$index, scope.row)"
              type="text"
              size="small"
              >生成授权文件</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange_authcode"
        @current-change="handlePageChange_authcode"
        :current-page="authCodeTable.currentPage"
        :page-sizes="authCodeTable.pageSizes"
        :page-size="authCodeTable.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="authCodeTable.total"
      ></el-pagination>
    </div>
    <el-dialog
      :title="isDeviceId ? '编辑' : '添加授权设备'"
      :visible.sync="visible.isVisible"
      @close="close"
      width="60%"
    >
      <el-form
        label-position="left"
        :model="selectRow"
        ref="codeForm"
        label-width="120px"
        :rules="validateAuthcode"
      >
        <el-form-item label="授权用户的分类" prop="userGroup">
          <el-select
            v-model="selectRow.userGroup"
            placeholder="请选择"
            :disabled="isDeviceId ? true : false"
            clearable
          >
            <el-option label="手机版用户" :value="0"></el-option>
            <el-option label="全站仪版用户" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="签发人" prop="issuerName">
          <el-input v-model="selectRow.issuerName" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户名称" prop="userName">
          <el-input v-model="selectRow.userName" clearable></el-input>
        </el-form-item>
        <el-form-item label="生效时间" prop="effectiveTime">
          <el-date-picker
            v-model="selectRow.effectiveTime"
            type="datetime"
            placeholder="选择生效时间"
            @change="getEffectiveTime"
            clearable
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="过期时间" prop="expirationTime">
          <el-date-picker
            v-model="selectRow.expirationTime"
            type="datetime"
            placeholder="选择过期时间"
            clearable
            @change="getExpirationTime"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="签发时间" prop="issueTime">
          <el-date-picker
            v-model="selectRow.issueTime"
            type="datetime"
            placeholder="选择签发时间"
            clearable
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="合同号" prop="client">
          <el-input v-model="selectRow.contractNo" clearable></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="client">
          <el-input
            v-model="selectRow.remarks"
            type="textarea"
            placeholder="请输入内容"
            clearable
            :rows="2"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="设备信息"
          prop="channel"
          v-if="isDeviceId ? false : true"
        >
          <el-upload
           ref="formUpload"
            class="upload-demo"
            action
            accept=".key"
            :auto-upload="false"
            :limit="1"
            :on-change="handleUpload"
          >
            <el-button size="small" type="primary">选取设备信息文件</el-button>
            <div slot="tip" class="el-upload__tip">只能选取key文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item prop="moduleNum" label="授权模块">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
          <el-checkbox-group
            v-model="selectRow.moduleNum"
            @change="handleCheckedModuleChange"
          >
            <el-checkbox
              v-for="item in moduleLists"
              :label="item.id"
              :key="item.id"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit('codeForm')"
            >确定</el-button
          >
          <el-button @click="close">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="添加成功" :visible.sync="suVisible" width="30%">
      <p>用户名称:{{ suData && suData.userName }}</p>
      <p>绑定的设备标识:{{ suData && suData.deviceId }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="suVisible = false">关 闭</el-button>
        <el-button type="primary" @click="sumitUplaod">下载授权文件</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import { upload } from '@/util/index'
var moment = require('moment')
import { saveAs } from 'file-saver'
export default {
  data () {
    return {
      moment: moment,
      addresCode: '',
      // addresName:'',
      isDeviceId: '',
      codeFileName: '',
      suVisible: false,
      suData: {},
      // 授权模块
      checkAll: false,
      checkedCities: ['上海', '北京'],
      checkedModule: [], // 授权模块
      moduleLists: [
        { id: '1', name: '水准测量' },
        { id: '2', name: '导线测量' },
        { id: '3', name: '水平角观测' },
        { id: '4', name: '竖直角观测' },
        { id: '5', name: '后方交会' },
        { id: '6', name: '坐标传输' },
        { id: '7', name: '参考线放样' },
        { id: '8', name: '高斯投影' },
        { id: '9', name: '坐标正形变换' },
        { id: '10', name: '坐标线性变换' },
        { id: '11', name: '水准网平差' },
        { id: '12', name: '平面网平差' },
        { id: '13', name: '秩亏网平差' },
        { id: '14', name: '地形图测绘' },
        { id: '15', name: 'GNSS寻点' },
        { id: '16', name: '缓曲半径计算' },
        { id: '17', name: '单线元' },
        { id: '18', name: 'QC28拆交点' },
        { id: '19', name: 'Q2X8交点法' },
        { id: '20', name: 'Q2X9线元法' },
        { id: '21', name: '桥台锥坡' },
        { id: '22', name: '路基横断面' },
        { id: '23', name: '边坡' },
        { id: '24', name: '隧道轮廓线' },
        { id: '25', name: '隧道超欠挖' },
        { id: '26', name: '桥梁墩台桩基' },
        { id: '27', name: '涵洞碎部点' },
        { id: '28', name: 'RTK设置' }
      ],
      isIndeterminate: false,
      options: {},
      activeName: 'user',
      issueTime: [],
      effectivetime: [],
      searchform: {},
      authCodeList: [],
      authCodeTable: {
        total: 0,
        pageSizes: [10, 20, 50],
        pageSize: 20,
        currentPage: 1
      },
      visible: {
        isVisible: false,
        updateDialogVisible: false
      },
      validateUser: {
        company: [
          {
            required: true,
            message: '请输入单位或学校名称'
          }
        ],
        tel: [
          {
            required: true,
            message: '请输入手机号码'
          }
        ],
        androidId: [
          {
            required: true,
            message: '请输入设备编号'
          }
        ]
      },
      validateAuthcode: {
        userGroup: [
          { required: true, message: '请选择授权用户分类', trigger: 'change' }
        ],
        issuerName: [
          { required: true, message: '请输入签发人', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入用户名称', trigger: 'blur' }
        ],
        effectiveTime: [
          { required: true, message: '请选择生效时间', trigger: 'change' }
        ],
        expirationTime: [
          { required: true, message: '请选择过期时间', trigger: 'change' }
        ],
        issueTime: [
          { required: true, message: '请选择签发时间', trigger: 'change' }
        ],
        moduleNum: [
          {
            type: 'array',
            required: true,
            message: '至少选择一个授权模块',
            trigger: 'change'
          }
        ]
      },
      createData: {},
      selectRow: {
        userGroup: '',
        issuerName: '',
        userName: '',
        effectiveTime: '',
        expirationTime: '',
        issueTime: '',
        contractNo: '',
        remarks: '',
        applicationCode: '',
        moduleNum: []
      },
      resetPassword: false
    }
  },
  created: async function () {
    let data = {}
    data.page = this.authCodeTable.currentPage
    data.size = this.authCodeTable.pageSize
    let res = await this.$$getAuthCodeList(data)
    this.authCodeList = res.list
    this.authCodeTable.total = res.total
  },
  mounted () {},
  methods: {
    resetForm () {
      this.isDeviceId = ''
      this.selectRow = {
        userGroup: '',
        issuerName: '',
        userName: '',
        effectiveTime: '',
        expirationTime: '',
        issueTime: '',
        contractNo: '',
        remarks: '',
        applicationCode: '',
        moduleNum: []
      }
      if (this.$refs.codeForm) {
        this.$refs.codeForm.resetFields()
      }
    },
    refreshAuthCodeList: async function () {
      this.searchform.page = this.authCodeTable.currentPage
      this.searchform.size = this.authCodeTable.pageSize
      let res = await this.$$getAuthCodeList(this.searchform)
      this.authCodeTable.total = res.total
      this.authCodeList = res.list
    },
    close () {
      this.checkAll = false
      this.visible.isVisible = false
      if (!this.isDeviceId) {
        this.$refs.formUpload.clearFiles()
      }
    },
    addAuthcode () {
      this.resetForm()
      this.checkAll = false
      this.visible.isVisible = true
      this.isIndeterminate = false
    },
    editAuthcode (index, item) {
      this.resetForm()
      this.visible.isVisible = true
      this.isDeviceId = item.deviceId
      this.selectRow.userGroup = item.userGroup
      this.selectRow.issuerName = item.issuerName
      this.selectRow.effectiveTime = moment.utc(item.effectiveTime).local().format('YYYY-MM-DD HH:mm:ss')
      this.selectRow.userName = item.userName
      this.selectRow.expirationTime = moment.utc(item.expirationTime).local().format('YYYY-MM-DD HH:mm:ss')
      this.selectRow.issueTime =   moment.utc(item.issueTime).local().format('YYYY-MM-DD HH:mm:ss')
      
      this.selectRow.contractNo = item.contractNo
      this.selectRow.remarks = item.remarks
      let checkedMNun = item.moduleNum && item.moduleNum.split(',')

      this.moduleLists.forEach((item) => {
        if (checkedMNun.indexOf(item.id) != -1) {
          this.selectRow.moduleNum.push(item.id)
        }
      })
      let checkedCout = checkedMNun.length
      this.isIndeterminate =
        checkedCout > 0 && checkedCout < this.moduleLists.length
      this.checkAll = checkedCout == this.moduleLists.length
    },
    deleteAuthcode (index, row) {
      let deviceId = row.deviceId
      this.$confirm('此操作将该条授权记录永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await this.$$deleteAuthcode(deviceId).then(() => {
            this.$message.success('删除成功！')
            this.refreshAuthCodeList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    createAuthcode (index, item) {
      // 列表生成授权文件
      let deviceId = item.deviceId
      this.deviCode(deviceId)
    },
    async deviCode (deviceId) {
      let res = await this.$$getAuthCodeByRecord({ deviceId })
      let codeToken = res.token
      let userGroup = res.userGroup
      let day = moment().format('YYYYMMDDHHmmss')
      let codeTableName = ''
      userGroup == 0
        ? (codeTableName = `mpac-${day}`)
        : (codeTableName = `mtac-${day}`)
      codeToken ? this.downLoadFile(codeToken, codeTableName) : ''
    },
    downLoadFile (code, name) {
      // 下载授权码
      if (code) {
        let str = new Blob([code], { type: 'text/plain;charset = utf-8' })
        saveAs(str, `${name}.licence`)
      }
    },
    sumitUplaod () {
      // 添加后下载
      if (this.addresCode) {
        this.downLoadFile(this.addresCode, this.codeFileName)
      }
    },
    // 授权模块全选
    handleCheckAllChange (val) {
      let ids = this.moduleLists.map((i) => {
        return i.id
      })
      this.selectRow.moduleNum = val ? ids : []
      this.isIndeterminate = false
    },
    // 选中的授权模块
    handleCheckedModuleChange (val) {
      let checkedCount = val.length
      this.checkAll = checkedCount == this.moduleLists.length
      this.selectRow.moduleNum = val
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.moduleLists.length
    },
    handleSubmit () {
      this.$refs.codeForm.validate(async (valid) => {
        if (valid) {
          // 添加或编辑
            let params = {
              applicationCode:this.selectRow.applicationCode|| '',
              contractNo:this.selectRow.contractNo || '',
              effectiveTime: moment(this.selectRow.effectiveTime).utc().format('YYYY-MM-DD HH:mm:ss') || '',
              expirationTime:moment(this.selectRow.expirationTime).utc().format('YYYY-MM-DD HH:mm:ss') || '',
              issueTime:moment(this.selectRow.issueTime).utc().format('YYYY-MM-DD HH:mm:ss') || '',
              issuerName:this.selectRow.issuerName || '',
              remarks:this.selectRow.remarks || '',
              userGroup:this.selectRow.userGroup || '',
              userName:this.selectRow.userName || '',
              moduleNum:this.selectRow.moduleNum.toString() || '',
            }
          if (this.isDeviceId) {
            params.deviceId =  this.isDeviceId
             const payloadUp =Object.assign({},params)
            this.visible.isVisible = false
            let upres = await this.$$updateAuthCodeRecord(payloadUp)
            this.$message({
              showClose: true,
              message: '编辑成功！',
              type: 'success'
            })
            this.suData = upres
            this.refreshAuthCodeList()
          } else {
            if (this.selectRow.applicationCode) {
                const payloadAdd =Object.assign({},params)
              let addres = await this.$$addAuthCodeByParams(payloadAdd)
               this.visible.isVisible = false
              this.suData = addres
              this.addresCode = addres.token
              this.suData ? (this.suVisible = true) : ''
              this.$refs.formUpload.clearFiles()
              this.refreshAuthCodeList()

            } else {
              this.$message({
                showClose: true,
                message: '请上传设备信息文件',
                type: 'error'
              })
              return ' '
            }
          }
        }
      })
    },
    resetSearchForm () {
      this.effectivetime = ''
      this.issueTime = ''
      this.searchform = {
        userName: '',
        userGroup: '',
        issueTimeStart: '',
        issueTimeEnd: '',
        validTimeStart: '',
        validTimeEnd: ''

      }
      let payload = { ...this.searchform }
      this.authCodeTable.currentPage = 1
      this.refreshAuthCodeList(payload)
    },
    searchAuthcode () {

      let payload = { ...this.searchform }
      this.authCodeTable.currentPage = 1
      this.refreshAuthCodeList(payload)
    },
    handleFileSeach (params) {
      // 根据文件查询列表
      this.upload(params).then(async (res) => {
        let code = res
        let codeRes = await this.$$getHistoricalDetailByCode(code)
        if (codeRes.deviceId) {
          this.authCodeList = [{ ...codeRes }]
          this.authCodeTable.total = this.authCodeList.length
          this.$refs.seachUpload.clearFiles()
        } else {
          this.authCodeList = []
          this.authCodeTable.total = 0
          this.$refs.seachUpload.clearFiles()
        }
      })
    },
    handleIssueTime (time) {
      this.searchform.issueTimeStart = time ? moment(time[0]).utc().format('YYYY-MM-DD HH:mm:ss') : ''
      this.searchform.issueTimeEnd = time ? moment(time[1]).utc().format('YYYY-MM-DD HH:mm:ss') : ''
    },
    handleEffTime (time) {
      this.searchform.validTimeStart = time ? moment(time[0]).utc().format('YYYY-MM-DD HH:mm:ss') : ''
      this.searchform.validTimeEnd = time ? moment(time[1]).utc().format('YYYY-MM-DD HH:mm:ss') : ''
    },
    handleSizeChange_authcode (val) {
      this.authCodeTable.pageSize = val
      this.refreshAuthCodeList()
    },
    handlePageChange_authcode (val) {
      this.authCodeTable.currentPage = val
      this.refreshAuthCodeList()
    },
    indexMethod_authcode (index) {
      return (
        index +
        1 +
        this.authCodeTable.pageSize * (this.authCodeTable.currentPage - 1)
      )
    },
    upload (e) {
      // 获取上传文件内容
      return new Promise(function (resolve) {
        let reader = new FileReader()
        reader.readAsBinaryString(e.raw)
        reader.onload = function () {
          resolve(this.result)
        }
      })
    },
    handleUpload (file) {
      this.codeFileName = file.name.split('.')[0]
      this.upload(file).then((res) => {
        if (res) {
          this.selectRow.applicationCode = res
        }
      })
    },

    getEffectiveTime (time) {
      // 获取生效时间
      if (this.selectRow.expirationTime) {
        let startDate = new Date(time).getTime()
        let endDate = new Date(this.selectRow.expirationTime).getTime()
        if (startDate > endDate) {
          this.$message({
            showClose: true,
            message: '生效时间应在过期时间之前！',
            type: 'warning'
          })
          this.selectRow.effectiveTime = ''
        } else {
          this.selectRow.effectiveTime = time
        }
      }
    },
    getExpirationTime (time) {
      if (this.selectRow.effectiveTime) {
        let startDate = new Date(this.selectRow.effectiveTime).getTime()
        let endDate = new Date(time).getTime()
        if (startDate > endDate) {
          this.$message({
            showClose: true,
            message: '过期时间应在生效时间之后！',
            type: 'warning'
          })
          this.selectRow.expirationTime = ''
        } else {
          this.selectRow.expirationTime = time
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.authcode {
  //   height: 100%;
  //     padding: 24px;
  //     box-sizing: border-box;
  //     background-color: rgb(240,242,245);
}
.feature-container {
  margin: 20px;
  background-color: #ffffff;
}
.list-container {
  margin: 20px;
}
.card {
  margin-top: 24px;
}
.reset-pass {
  text-align: left;
}
</style>
